export function goToWallet(event, locale) {
  const localeUrl = locale ? "ru" : "";
  const walletUrl = `https://wallet.emcd.io/${localeUrl}`;

  if (event.ctrlKey || event.metaKey || event.button === 1) {
    // Открываем в новой вкладке
    window.open(walletUrl, "_blank");
  } else {
    // Обычный переход по имени маршрута
    window.open(walletUrl);
  }
}

export const NETWORK_ENUMS = {
  bitcoin: "bitcoin",
  tron: "tron",
  usdt: "usdt",
  ton: "ton",
  ethereum: "ethereum",
};
